import BaseInputComponent from "basecomponents/BaseInputComponent";

// Components
import { InputField } from "../components/form";

// Utils
import { copyToClipboard } from "../utils/domUtils";

class AdminDCalculator extends BaseInputComponent {
  state = {
    alto: 0,
    ancho: 0,
    largo: 0,
    peso: 0,
  };

  defaultDIMDivisor = 166;

  getCalResult = () => {
    const { alto, ancho, largo, peso } = this.state;
    let dimWeight = (largo * ancho * alto) / this.defaultDIMDivisor;
    let weight = parseFloat(`${peso}`);

    return {
      dim: dimWeight > weight,
      weight: weight > dimWeight,
      dimWeight: dimWeight.toFixed(2),
      realWeight: weight.toFixed(2),
    };
  };

  getForm = () => {
    const { alto, ancho, largo, peso } = this.state;
    return (
      <>
        <div className="grid-2-col">
          <InputField
            id="alto"
            name="alto"
            value={alto}
            label="Alto"
            onChange={this.onChangeTextInput}
            type="number"
          />

          <InputField
            id="ancho"
            name="ancho"
            value={ancho}
            label="Ancho"
            onChange={this.onChangeTextInput}
            type="number"
          />
        </div>

        <div className="grid-2-col">
          <InputField
            id="largo"
            name="largo"
            value={largo}
            label="Largo"
            onChange={this.onChangeTextInput}
            type="number"
          />

          <InputField
            id="peso"
            name="peso"
            value={peso}
            label="Peso"
            onChange={this.onChangeTextInput}
            type="number"
          />
        </div>
      </>
    );
  };

  getCalc = () => {
    const result = this.getCalResult();
    return (
      <div className="grid-2-col">
        <div
          className="box-result cursor-pointer"
          onClick={() => {
            copyToClipboard(result.dimWeight);
          }}
        >
          <div className={`box-value ${result.dim ? "text-green" : ""}`}>
            {result.dimWeight} Lbs
          </div>
          <div className="box-label">Peso DIM</div>
        </div>

        <div
          className="box-result cursor-pointer"
          onClick={() => {
            copyToClipboard(result.realWeight);
          }}
        >
          <div className={`box-value ${result.weight ? "text-green" : ""}`}>
            {result.realWeight} Lbs
          </div>
          <div className="box-label">Peso real</div>
        </div>
      </div>
    );
  };

  render() {
    return (
      <>
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <div className="card-title">
                  <span>Calculadora de peso</span>
                </div>
                <div className="card-body">
                  <span className="form-label">
                    Utilizar medidas en pulgadas y peso en libras
                  </span>
                  {this.getForm()}
                  {this.getCalc()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default AdminDCalculator;
